import { h, Component, Prop } from "@stencil/core";
import { track } from "../../utils/tracking";

@Component({
    tag: "ux-iws-nb-technical-data-download-button",
    styleUrl: "nb-technical-data-download-button.scss",
    shadow: false,
})
export class NbTechnicalDataDownloadButton {
    private baseClass = "ux-iws-nb-technical-data-download-button";
    /** The URL to the download file. */
    @Prop() downloadUrl?: string;
    /** The text for the download link. */
    @Prop() downloadLabel?: string;
    /** Additional information text for the download link. E.g. "PDF - 2 MB" */
    @Prop() downloadInfo?: string;
    /** The file name for the downloaded file. */
    @Prop() downloadFileName?: string;

    render() {
        return (
            <a
                class={this.baseClass}
                onClick={() => {
                    track("click_download_technical_data", {});
                }}
                href={this.downloadUrl}
                download={this.downloadFileName}
            >
                <span class={`${this.baseClass}__label`}>
                    {this.downloadLabel}
                </span>
                <span class={`${this.baseClass}__info`}>
                    {this.downloadInfo}
                </span>
                <span class={`${this.baseClass}__icon`}>
                    <ux-icon name="download" />
                </span>
            </a>
        );
    }
}
